import type { BoxProps } from "@mui/material";
import { Box } from "@mui/material";
import useLazyRenderList from "../hooks/useLazyRenderList";

interface Props extends BoxProps {
  chunkSize?: number;
}

const BoxWithLazyRender = ({ chunkSize, children, onScroll, ...boxProps }: Props) => {
  const { loadMore, loadedItems } = useLazyRenderList({ children, chunkSize });

  // Compose any caller/MUI-supplied onScroll with loadMore so the spread does not drop lazy loading.
  const handleScroll: React.UIEventHandler<HTMLDivElement> = (event) => {
    onScroll?.(event);
    loadMore();
  };

  return (
    <Box role="listbox" {...boxProps} onScroll={handleScroll}>
      {loadedItems}
    </Box>
  );
};

export default BoxWithLazyRender;
